"use client";

import { useMenubarStore } from "./UZXETJJN.js";
import { MenubarContextProvider } from "./QVEJ36PB.js";

// src/menubar/menubar-provider.tsx
import { jsx } from "react/jsx-runtime";
function MenubarProvider() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = useMenubarStore(props);
  return /* @__PURE__ */jsx(MenubarContextProvider, {
    value: store,
    children: props.children
  });
}
export { MenubarProvider };